module.exports = __webpack_public_path__ + "img/2.d9f482a5.jpg";